export default theme => ({
    stepperInputControl: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        borderRadius: '24px',
        padding: '2px',
        border: '1px solid #e0e0e0',
    },
    stepperInputValue: {
        minWidth: '30px',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '1rem',
    },
});